<template>
    <div id="MyResultDiv">
        <HeaderVue isHeader="true"/>
        <div class="container-fluid static-content">
            <div class="row">
                <div class="col-12">
                    <div class="signup-title">
                        <h4 class="mt-0 mb-0 text-center">My Results</h4>
                    </div>
                </div>
            </div>
            <router-link to="/referral/invite" class="w-100 referal-image" >
                <img src="static/images/referral_mobile_banner.jpg" class="responsive-result-image" alt="" />
            </router-link>
            <div class="row mt-3">
                <div class="col-sm-12">
                    <div class="report-list">
                        <div class="report" v-for="(item, index) in limitBy(totalReports, reportLimit)" :key="index">
                            <div class="label-data">
                                <h6 class="m-0 text-warning float-right">
                                    <span v-if="item.requestStatus === -1" >Payment Pending</span>
                                    <span class="text-danger"  v-if="item.requestStatus === -2" >Payment Failure</span>
                                    <span class="text-success "  v-if="item.requestStatus === 0 || item.requestStatus === 2" >Requested</span>
                                    <span   v-if="item.requestStatus === 1 || item.requestStatus === 12" >Phelebotomist Accepted</span>
                                    <!--<span class="m-0 text-warning"  v-if="item.requestStatus === 2" >Phelebotomist Cancelled</span>-->
                                    <span   v-if="item.requestStatus === 3" >Sample Collected</span>
                                    <span class=" text-success"  v-if="item.requestStatus === 4 || item.requestStatus === 5 || item.requestStatus === 7" >Sample Delivered to Lab</span>
                                    <!--<span class="m-0 text-warning"  v-if="item.requestStatus === 5" >Report Pending for </span>-->
                                    <!--<span class="m-0 text-warning"  v-if="item.requestStatus === 6" v-on:click="viewReport(item.requestId)">View PDF</span>-->
                                    <!--<span class="m-0 text-warning"  v-if="item.requestStatus === 7" >Report Rejected</span>-->
                                    <span class="text-danger"  v-if="item.requestStatus === 8" >Cancelled</span>
                                    <span class="text-secondary"  v-if="item.requestStatus === 9"  >Refund</span>
                                    <span class="text-danger"  v-if="item.requestStatus === 11"  >Payment Processing</span>
                                    
                                    <button class="btn btn-sm text-nowrap btn-primary" v-else-if="item.requestStatus === 6" v-on:click="viewReport(item.requestId)">View PDF</button>
                                    
                                </h6>
                                <p>
                                   Request No
                                </p>
                                <p>
                                   REQ{{item.requestId}}
                                </p>
                            </div>
                            <div class="label-data">
                                <p>
                                    Patient Name
                                </p>
                                <p>
                                    {{item.reqPatientFirstName+ ' '+ item.reqPatientLastName}}
                                </p>
                            </div>
                            <div class="label-data">
                                <p>
                                    Date/Time
                                </p>
                                <p>
                                    {{formatDate((item.appointmentDate), 'dd/mm/yyyy')}}<br>
                                    {{item.appointmentFromTime}} - {{item.appointmentToTime}}
                                </p>
                            </div>
                            <div class="label-data">
                                <p>
                                    Test / Profile
                                </p>
                                <p>
                                    {{(item.requestTestList).join(', ')}}
                                </p>
                            </div>
                            <div class="label-data">
                                <p>
                                    Lab Name / Locality
                                </p>
                                <p>
                                    {{item.labName}}<br>
                                    <span class="grey-color">{{item.labLocation+', '+item.labCity+' - '+item.labZipcode}}</span>
                                </p>
                            </div>
                            <div class="label-data">
                                <p>
                                    Report Date
                                </p>
                                <p>
                                   {{(item.reportDeliveredDate)?(formatReportDate(item.reportDeliveredDate, 'dd/mm/yyyy hh:MM TT')):'-' }}
                                </p>
                            </div>
                        </div>
                        <div class="col-12"  v-if="totalReports.length <= 0 && isLoading"> 
                            <span>Loading </span>
                        </div>
                        <div class="col-12"  v-if="totalReports.length <= 0 && !isLoading">
                            <span> No records found </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12" style="text-align:center !important;padding-bottom:8%;" >
              <button class="btn btn-outline-primary align-center" v-if="totalReports.length > reportLimit" v-on:click="loadMore()" >Show more Results({{totalReports.length - reportLimit}})</button>
            </div>
        </div>
        <!-- <div class="contact-info">
            <div class="container">
                <ul class="row text-center">
                    <li>
                        <span class="sprites sprite-mail align-center"></span>
                        <p><a href="mailto:support@labotist.com" target="_top"> support@labotist.com </a></p>
                    </li>
                    <li>
                        <span class="sprites sprite-call align-center"></span>
                        <p><a href="tel:+919025662566">+91 90256 62566</a></p>
                    </li>
                </ul>
            </div>
        </div> -->
        <FooterVue />
        <pdfviewer @closepdf="closepdf" v-model="isshowpdf" :pdfurl="pdfurls" @pdferr="pdferr" :maxscale='4' :minscale='0.5' :scale='0.5' :desiredWidth="2"></pdfviewer>
    </div>
</template>

<script>
import HeaderVue from '@/components/mobile/Header'
import FooterVue from '@/components/mobile/Footer'
import dateFormat from 'dateformat'
import detectBrowser  from 'detect-browser'
import pdfviewer from '@/components/plugin/vue-pdfviewer'

export default {
  name: 'MyResult',
  props: [],
  components: {
    HeaderVue,
    FooterVue,
    pdfviewer
  },
  beforeCreate () {
    if (!this.$localStorage.get('loggedIn') || this.$localStorage.get('loggedIn') === null) {
      this.$router.push({ path: '/' })
    }
  },
  data () {
    return {
      loadMorePerHit: 10,
      reportLimit: 10,
      totalReports: [],
      reportList: [],
      limitedReportList: [],
      isLoading : false,
      deviceData : undefined,
      pdfurls:'',
      isshowpdf:false
    }
  },
  created () {
    this.patientReports()
    this.deviceData = detectBrowser.detect();
  },
  methods: {
    closepdf(){
        this.isshowpdf = false
        this.pdfurls = ''
    },
    pdferr(errurl) {
        console.log(errurl);
        this.pdfurls = ''
        this.isshowpdf = false
        // alert('Unable to fetch Report try again')
        this.$Simplert.open({
            title: 'Oops',
            message: 'Unable to fetch Report try again',
            type: 'warning',
            disableOverlayClick: true,
            showXclose: true,
            useConfirmBtn: false,
            customCloseBtnText: 'OK'
        })
    },
    loadMore: function () {
      var increamented = this.reportLimit + this.loadMorePerHit
      this.reportLimit = increamented > this.totalReports.length ? this.totalReports.length : increamented
    },
    formatDate: function (date, format) {
      let dateSplit = date.split(' ')
      return dateFormat((dateSplit[0] + 'T' + dateSplit[1]), format, true)
    },
    formatReportDate: function (date, format) {
      return dateFormat(date, format)
    },
    patientReports: function () {
      try {
        this.reportList = []
        let data = {}
        this.isLoading = true
        Promise.resolve(this.$POST('patient/patientReports', data)).then(function (res) {
          if (res.response_code === 0) {
            this.totalReports = (res.response)
            this.isLoading = false
          }else{
            this.isLoading = false
          }
          this.$hidePageLoading()
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.error(e)
      }
    },
    viewReport: function (requestId) {
      try {
        this.reportList = []
        let data = {
          requestId: requestId
        }
        Promise.resolve(this.$GET('patient/viewReport', data)).then(function (res) {
          if (res.response_code === 0) {
            if(this.$WebView && this.$WebViewBridge) {
              let data = {
                type : 'openReport',
                requestId : res.response.requestId ? 'REQ'+res.response.requestId  : '',
                pdfUrl : res.response.url
              }
              this.$WebViewBridge.send(JSON.stringify(data));
            } else {
              try {
                // var popupWindow = window.open(res.response.url, '_blank')
                // popupWindow.focus()
                this.pdfurls = res.response.url
                this.isshowpdf = true
              } catch (e) {
                //   this.popupBlockerAlert()
              }
            }
            
          } else {
            this.$Simplert.open({
              title: 'Oops',
              message: res.response_message,
              type: 'warning',
              disableOverlayClick: true,
              showXclose: true,
              useConfirmBtn: false,
              customCloseBtnText: 'OK'
            })
            // alert(res.response_message)
          }
        }.bind(this)).catch(function (err) {
          console.error(err)
        })
      } catch (e) {
        console.error(e)
      }
    },
    popupBlockerAlert: function () {
        if(this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Windows') > -1) {
         this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                        <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>
                        <strong>2. </strong> Select <strong>Settings</strong>.<br>
                        <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>
                        <strong>4. </strong> Under Privacy, click the <strong>Content Settings</strong> button.<br>
                        <strong>5. </strong> To disable the pop-up blocker check the <strong>Allow all sites to show pop-ups</strong> box.<br>
                        <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).
                    </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
         })
        } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Mac') > -1) {
         this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> Click the <strong>Customize and control Google Chrome</strong> menu (the three horizontal bars in the upper right corner)<br>
                    <strong>2. </strong>  Select <strong>Settings</strong>.<br>
                    <strong>3. </strong> Click the <strong>Show advanced settings...</strong> at the bottom.<br>
                    <strong>4. </strong> Under <strong>Privacy</strong>, click the <strong>Content Settings</strong> button.<br>
                    <strong>5. </strong> To disable the pop-up blocker check the Allow all sites to show pop-ups box.<br>
                    <strong>6. </strong> To enable pop-ups on specific sites, check <strong>Do not allow any site to show pop-ups</strong> (recommended) and click Exceptions and enter this URL(<strong>https://labotist.com</strong>).<br>
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
         })
        } else if (this.deviceData.name === 'chrome' && this.deviceData.os.indexOf('Android') > -1) {
         this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>
                <strong>2. </strong>  Tap <strong>Site settings</strong> and then <strong>Pop-ups</strong>.<br>
                <strong>3. </strong> Turn <strong>Pop-ups</strong> to <strong>Allowed</strong>.
                </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
         })
        } else if (this.deviceData.name === 'crios' && this.deviceData.os.indexOf('iOS') > -1) {
         this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                    <strong>1. </strong> To the right of the address bar, tap More  and then <strong>Settings</strong>.<br>
                    <strong>2. </strong>  Tap <strong>Content Settings</strong> and then <strong>Block Pop-ups</strong>.<br>
                    <strong>3. </strong> Turn <strong>Block pop-ups</strong> off.
                </div>`,
           type: 'warning',
           disableOverlayClick: true,
           showXclose: true,
           useConfirmBtn: false,
           customCloseBtnText: 'OK'
         })
        } else if (this.deviceData.name === 'safari' && this.deviceData.os.indexOf('Mac') > -1) {
         this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                        <strong>1. </strong> From the <strong>Safari</strong> menu, select <strong>Preferences</strong><br>
                        <strong>2. </strong>  Click <strong>Security</strong> at the top of the window<br>
                        <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.
                    </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
         })
        } else if (this.deviceData.name === 'ios' && this.deviceData.os.indexOf('iOS') > -1) {
         this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                        <strong>1. </strong> Launch <strong>Settings</strong>.<br>
                        <strong>2. </strong>  Tap <strong>Safari</strong>.<br>
                        <strong>3. </strong> Under the <strong>General section</strong>, click the toggle next to <strong>Block Pop-ups</strong> to <strong>disable</strong> the pop-up blocker. A green toggle indicates an enabled pop-up blocker.
                    </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
         })
        } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Mac') > -1) {
         this.$Simplert.open({
          title: 'Popup Blocked',
          message: `<div style="text-align: left; line-height: 25px;">
                        <strong>1. </strong> Select <strong>Preferences</strong> from the <strong>Firefox</strong> menu.<br>
                        <strong>2. </strong>  Choose the <strong>Content</strong> button.<br>
                        <strong>3. </strong> Uncheck the <strong>Block pop-up windows</strong> box.
                    </div>`,
          type: 'warning',
          disableOverlayClick: true,
          showXclose: true,
          useConfirmBtn: false,
          customCloseBtnText: 'OK'
         })
        } else if (this.deviceData.name === 'firefox' && this.deviceData.os.indexOf('Windows') > -1) {
            this.$Simplert.open({
                title: 'Popup Blocked',
                message: `<div style="text-align: left; line-height: 25px;">
                            <strong>1. </strong> Click the <strong>"hamburger" menu icon (top right) </strong> to open the Firefox menu.<br>
                            <strong>2. </strong> Click <strong>Options</strong>.<br>
                            <strong>3. </strong> Click <strong>Privacy & Security</strong> menu.<br>
                            <strong>4. </strong> Under <strong>Permission</strong> menu make sure that <strong>Block pop-up windows</strong> is activated (checkbox).<br>
                            <strong>5. </strong> Click the <strong>Exceptions</strong> button located to the right of Block pop-up windows.<br>
                            <strong>6. </strong> You will see the Allowed Sites dialog box.<br>
                            <strong>7. </strong> To enable add <strong>https://labotist.com</strong> and then click <strong>Allow</strong>
                        </div>`,
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
            })
        } else {
            this.$Simplert.open({
                title: 'Popup Blocked',
                message: `Pop-up Blocker is enabled! Please add this site to your exception list.`,
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
            })
        }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mobile/Secure/MyResult.vue